import { styled } from '@pata-app/themes';

export const SectionContainerContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.core.sizing[1]}px;

  padding: 70px 32px;

  h2 {
    margin: 0;
    font-size: ${({ theme }) => theme.core.fontSizes.xxxl}px;
  }
  > p:first-of-type {
    margin: 0;
    font-size: 18px;
    font-family: ${({ theme }) => theme.core.fontFamily.jost};
  }

  @media ${({ theme }) => `${theme.core.breakpoints.l}`} {
    padding: 70px 0;
  }
`;
